import { formatEntityName, formatFieldName } from '../../../common';
import { createSchemaStatementHandler } from '../../createSchemaStatementHandler';
export const removeColumnStmtInstruction = `
#### Column removal

This statement removes a column from the database table.

- Syntax: \`remove column <entity_name>.<column_name>;\`
- Example: \`remove column Car.weight;\`

`;
export const stmtRemoveColumn = ({ entityName, columnName }) => {
    return `remove column ${entityName}.${columnName};`;
};
export const stmtForHumanRemoveColumn = ({ entityName, columnName }) => {
    return `Remove the column __${columnName}__ from the database table __${entityName}__.`;
};
export const removeColumnHandler = createSchemaStatementHandler({
    type: 'remove column',
    parse: line => {
        const match = /^remove (column|field) (?<entityName>\w+)\.(?<columnName>\w+)/.exec(line);
        return match?.groups
            ? {
                type: 'remove column',
                entityName: formatEntityName(match.groups.entityName),
                columnName: formatFieldName(match.groups.columnName),
            }
            : null;
    },
    getHumanStmt: stmtForHumanRemoveColumn,
    apply: (stmt, builder) => {
        builder.updateSchema(it => it.removeField(stmt.entityName, stmt.columnName));
    },
});
//# sourceMappingURL=RemoveColumnStmt.js.map